import { Divider, Drawer, IconButton, List, Theme } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { BACKGROUND_DRAWER_PRIMARY_COLOR } from 'constants/colors';
import React, { FC } from 'react';
import logo from '../../images/logo.png';
import DrawerList from './components/DrawerList';

interface Props {
  openDrawer: boolean;
  currentUserData: CurrentUser | undefined;
  handleDrawerClose(): void;
}

const { REACT_APP_DRAWER_WIDTH = '240' } = process.env;

const useStyles = makeStyles((theme: Theme) => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px'
  },
  drawerPaper: {
    background: BACKGROUND_DRAWER_PRIMARY_COLOR,
    position: 'relative',
    whiteSpace: 'nowrap',
    width: +REACT_APP_DRAWER_WIDTH,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9)
    }
  },
  logoContainer: {
    textAlign: 'center'
  },
  logo: {
    width: '35%',
  }
}));

const AppDrawer: FC<Props> = props => {
  const classes = useStyles(props);
  const { openDrawer, currentUserData, handleDrawerClose } = props;

  return (
    <Drawer
      variant='permanent'
      classes={{
        paper: clsx(classes.drawerPaper, !openDrawer && classes.drawerPaperClose)
      }}
      open={openDrawer}
    >
      <div className={classes.toolbarIcon}>
        <div className={classes.logoContainer}>
          <img src={logo} alt='Best Helper' className={classes.logo} />
        </div>
        <IconButton onClick={handleDrawerClose}>
          <ChevronLeftIcon />
        </IconButton>
      </div>
      <Divider />
      <List>
        <DrawerList
          handleDrawerClose={() => console.log('')}
          currentUserData={currentUserData}
          openDrawer={openDrawer}
        />
      </List>
    </Drawer>
  );
};

export default AppDrawer;
